module.exports = __webpack_public_path__ + "img/jobsmedia.68b9caae.svg";